<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_5"></a>A<span class="small">CKNOWLEDGMENTS</span></h2>
<p class="indent">This book is dedicated to my wife and best friend, Marsha Sims, and to my children, Kate, Taylor, and Elizabeth. Also to Pamela Eakins, Joyce Eakins, Jason Brenneman, and especially little James West Brenneman.</p>
<p class="indent">Marsha also deserves thanks for producing figures that clarify difficult but essential concepts.</p>
<p class="indent">I also thank Patrick Huyghe, whose contributions to <em>The God Theory</em> significantly helped its success and thereby led to the present book.</p>
<p class="indent"><a id="page_6"></a>I acknowledge the classical education I received at the Latin School of Indianapolis, which in its own way wound up leading me to this book. And thanks, LSI classmates.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?7e2895b6